import React, { lazy } from "react";
import { renderDashboardBasedOnRole } from "../Layouts/MainLayout";
import AllBlogs from "../Pages/AllBlogs/AllBlogs";

function DynamicDashboard() {
  // Call the renderDashboardBasedOnRole function to get the dashboard component
  const dashboardComponent = renderDashboardBasedOnRole();

  return (
    <React.Fragment>
      {/* Render the dashboard component */}
      <AllBlogs/>
      {dashboardComponent}
    </React.Fragment>
  );
}

export default DynamicDashboard;
